/**
 * Skava debug status page
 */
app.page.status = (function() {
    "use strict";
    var items = [
            [{
                "quantity": 1,
                "skus": [{
                    "skuId": "5634_1",
                    "productId": "5077",
                    "type": "DEFAULT"
                }],
                "properties": {},
                "isSubscription": false,
                "subscription": {}
            }],
            [{
                "quantity": 1,
                "skus": [{
                    "skuId": "3039_1",
                    "productId": "12982",
                    "type": "DEFAULT"
                }],
                "properties": {},
                "isSubscription": false,
                "subscription": {}
            }]
        ],
        address = {
            "addressLine1": "6419 SE 52nd Ave",
            "addressLine2": "",
            "city": "Portland",
            "country": "US",
            "email": "trentj@efn.org",
            "firstName": "Trent",
            "lastName": "Johnson",
            "phone": "5038693211",
            "state": "OR",
            "zip": "97206"
        },
        billing = {
            "value": "",
            "amount": "",
            "accountInfo": {
                "name": "Trent",
                "lastName": "Johnson",
                "cardNumber": "4111111111111111",
                "expiryMonth": "03",
                "expiryYear": "22",
                "cvv": "234"
            },
            "billingAddress": {
                "firstName": "Trent",
                "lastName": "Johnson",
                "addressLine1": "6419 SE 52nd Ave",
                "addressLine2": "",
                "city": "Portland",
                "state": "OR",
                "country": "US",
                "zip": "97206",
                "email": "trentj@efn.org",
                "phone": "5038693211"
            }
        },
        total = 0,
        products = [],

        self = {

        init: function() {
            app.pws.loadProducts(function() {
                products = app.pws.getProducts().src;

                app.page.postLoad({
                    page: 'status',
                    title: 'Status Page'
                }, self);
            });
        },

        render: function(data) {
            data.products = products;
            app.main.getTemplate('page-status', {}, true, function() {
                $('#page').html(app.main.getTemplate('page-status', data));
                self.postRender();
            });
        },

        postRender: function() {
            $('#btn-showCart').on('click', self.renderSkavaCart);

            $('#btn-atc').on('click', function() { self.setMode('cart'); });
            $('#btn-bwm').on('click', function() { self.setMode('bwm'); });

            $('#btn-session').on('click', self.startSession);
            $('#btn-getCart').on('click', self.getCart);
            $('.btn-add').on('click', self.addToCart);
            $('#btn-delete').on('click', self.deleteCart);

            $('#btn-login').on('click', self.login);
            $('#btn-address').on('click', self.sendAddress);
            $('#btn-shipping').on('click', self.sendShipping);
            $('#btn-billing').on('click', self.sendBilling);
            $('#btn-properties').on('click', self.sendProperties);
            $('#btn-order').on('click', self.sendOrder);

            $('#btn-ecommerce').on('click', self.sendEcommerce);

            $('#btn-clear').on('click', self.clearResponse);

            $('#field-product').on('change', self.setProduct);
            $('#btn-add-product').on('click', self.addProductToCart);

            self.setMode('cart');
        },

        /**
         * Just load the skava cart and display everything
         */
        renderSkavaCart: function() {
            app.pws.loadProducts(function(data) {

                app.skava.getCart(
                    function(res) {
                        self.showResponse(res);
                        self.showResponse('get cart success');
                        
                        var cartData = res;
                        console.log(cartData);

                        if (cartData.items) {
                            cartData.items.forEach(function(item) {
                                if (item.skus) {
                                    item.skus.forEach(function(sku) {
                                        var product = app.pws.getProductByID(sku.productId);
                                        item.product = product;
                                    });
                                }
                            });
                        }

                        cartData.origPrice = cartData.res.value.originalPrice * 100;
                        cartData.itemDiscount = cartData.res.value.itemDiscount * 100;

                        if (cartData.res.promotionDetails && cartData.res.promotionDetails.promotions) {
                            cartData.cartDiscount = cartData.res.promotionDetails.promotions[0].totalPrice * 100;
                        }

                        cartData.calculatedTotal = cartData.origPrice - cartData.itemDiscount - cartData.cartDiscount;

                        $('#cart-container').html(app.main.getTemplate('skava-cart', cartData));

                    },
                    function(err) {
                        self.showResponse('get cart failed. status '+ err.status);
                        $('#cart-container').empty();
                        console.log(err);
                    });
            });
        },

        setMode: function(mode) {
            app.skava.setShoppingMode(mode);
            self.showResponse('mode set to '+ mode);
        },

        startSession: function() {
            self.showResponse('---- startSession?');
            app.skava.setUpSession(
                function() {
                    self.showResponse('session success');
                },
                function(err) {
                    self.showResponse('session failed. status '+ err.status);
                });
        },

        getCart: function() {
            app.skava.getCart(
                function(res) {
                    self.showResponse(res);
                    self.showResponse('get cart success');
                    total = Math.round(res.grandTotal * 100) / 10000;
                    // console.log(total);
                    billing.value = total.toString();
                    billing.amount = billing.value;
                },
                function(err) {
                    self.showResponse('get cart failed. status '+ err.status);
                    console.log(err);
                });
        },

        addToCart: function(item) {
            var index = $(this).data('id');
            var data = item ? item : items[index];

            console.log(data);

            self.showResponse('---- addToCart?');
            app.skava.sendRequest({
                url: '/cart/',
                method: 'POST',
                data: JSON.stringify(data)
            },

            function(res) {
                self.showResponse('add to cart success');
            },

            function(err) {
                self.showResponse(err.responseText);
                self.showResponse('add to cart failed. status '+ err.status);
            });
        },

        addProductToCart: function() {
            var index = $('#field-product').val();
            var product = products[index];

            var data = [{
                "quantity": 1,
                "skus": [{
                    "skuId": product.sku_id,
                    "productId": product.product_id,
                    "type": "DEFAULT"
                }],
                "properties": {},
                "isSubscription": false,
                "subscription": {}
            }];

            if ($('#field-loyalty').is(':checked')) {
                console.log('isSubscription');
                data[0].isSubscription = true;
                data[0].subscription = {
                    "frequencyPeriod": "1",
                    "frequencyType": "MONTHS"
                };
            }

            self.addToCart(data);            
        },

        setProduct: function() {
            var index = $('#field-product').val();
            var product = products[index];

            if (product) {
                $('#product-name').text(product.name);

            } else {
                $('#product-name').empty();
            }
        },

        deleteCart: function() {
            self.showResponse('---- deleteCart?');
            app.skava.sendRequest({
                url: '/cart/',
                method: 'DELETE'
            },
            function(res) {
                self.showResponse('delete cart success');
            },
            function(err) {
                self.showResponse('delete cart failed. status '+ err.status);
            });
        },

        login: function() {
            var login = {
                username: "",
                password: ""
            };

            login.username = $('#field-username').val();
            login.password = $('#field-password').val();

            self.showResponse('---- login?');
            app.skava.sendRequest({
                url: '/login/',
                method: 'POST',
                data: JSON.stringify(login)
            },
            function(res) {
                self.showResponse('login success');
            },
            function(err) {
                self.showResponse('login failed. status '+ err.status);
                console.log(err);
            });
        },

        sendAddress: function() {
            self.showResponse('---- address?');
            app.skava.sendRequest({
                url: '/address/',
                method: 'POST',
                data: JSON.stringify(address)
            },
            function(res) {
                self.showResponse(res);
                self.showResponse('address success');
            },
            function(err) {
                self.showResponse('address failed. status '+ err.status);
                console.log(err);
            });
        },

        sendShipping: function() {
            var data = {
                id: "140"
            };

            self.showResponse('---- shipping?');
            app.skava.sendRequest({
                url: '/shipping/',
                method: 'POST',
                data: JSON.stringify(data)
            },
            function(res) {
                self.showResponse('shipping success');
            },
            function(err) {
                self.showResponse('shipping failed. status '+ err.status);
                console.log(err);
            });
        },

        sendProperties: function() {
            app.skava.sendRequest({
                url: '/properties/',
                method: 'POST',
                data: JSON.stringify({
                    referralId: 13348094,
                    isTCVersionChecked: true
                })
            },
            function(res) {
                self.showResponse('properties success');
            },
            function(err) {
                self.showResponse('properties failed. status '+ err.status);
                console.log(err);
            });
        },

        sendBilling: function() {
            self.showResponse('---- billing?');
            app.skava.sendRequest({
                url: '/billing/',
                method: 'POST',
                data: JSON.stringify(billing)
            },
            function(res) {
                self.showResponse('billing success');
            },
            function(err) {
                self.showResponse('billing failed. status '+ err.status);
                console.log(err);
            });
        },

        sendOrder: function() {
            self.showResponse('---- order?');
            app.skava.sendRequest({
                url: '/order/',
                method: 'POST'
            },
            function(res) {
                self.showResponse(res);
                self.showResponse('order success');
            },
            function(err) {
                self.showResponse('order failed. status '+ err.status);
                console.log(err);
            });
        },

        sendEcommerce: function() {
            var item1 = {
                "id": "111111122222222",
                "name": "Bath & Shower Gel Base",
                "sku": "3751_1",
                "category": 6,
                "price": 22.04,
                "quantity": 1,
                "currency": "USD"
            };

            var item2 = {
                "id": "111111122222222",
                "name": "Bath & Shower Gel - Morning Start",
                "sku": "3745_1",
                "category": 6,
                "price": 26.32,
                "quantity": 1,
                "currency": "USD"
            };

            var transaction = {
                "id": "111111122222222",
                "affiliation": 12235709,
                "revenue": 56.01,
                "shipping": 6.99,
                "tax": 0,
                "dimension7": "test-transaction"
            };

            self.showResponse('ecommerce:addItem 1');
            self.showResponse(item1);
            ga('ecommerce:addItem', item1);

            self.showResponse('ecommerce:addItem 2');
            self.showResponse(item2);
            ga('ecommerce:addItem', item2);

            self.showResponse('ecommerce:addTransaction');
            self.showResponse(transaction);
            ga('ecommerce:addTransaction', 'purchase', transaction);

            self.showResponse('ecommerce:send');
            ga('ecommerce:send');
        },

        showResponse: function(data) {
            if (typeof data == 'object') {
                data = JSON.stringify(data, undefined, 2);
            }
            $('#response-container pre').prepend(data +'\n');
        },

        clearResponse: function() {
            $('#response-container pre').empty();
        }

    };

    return self;
}());
